document.addEventListener('octane.quiz.addToCart', async function (e) {
  const data = e.detail;
  
  if (!data?.items?.length) {
    console.warn("[Octane] No items found in quiz response");
    return;
  }

  let addedAnyItem = false;

  for (const item of data.items) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: item.id,
          quantity: item.quantity || 1,
          properties: item.properties || {}
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("[Cart] Add to cart failed:", errorText);
        continue;
      }

      const addedItem = await response.json();
      console.log("✅ Product added:", addedItem);
      addedAnyItem = true;

      // Update cart count
      try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        if (window.Alpine?.store('cart_count')) {
          Alpine.store('cart_count').count = cart.item_count;
        } else {
          document.querySelectorAll('.cart_count_class').forEach(el => {
            el.innerText = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
        }
      } catch (cartError) {
        console.error("[Cart] Failed to update cart count:", cartError);
      }

      // Redirect to Shopflo cart if available
      // (Do not open theme's native cart drawer)
      // Intentionally no-op here to avoid multiple triggers in the loop

    } catch (err) {
      console.error("[Cart] Unexpected error:", err);
    }
  }
  // Trigger Shopflo cart once after all items are added
  if (addedAnyItem && typeof window.handleFloCartBtn === 'function') {
    window.handleFloCartBtn();
  }
});
